import { render, staticRenderFns } from "./SelfPaced.vue?vue&type=template&id=19202353"
import script from "./SelfPaced.vue?vue&type=script&lang=js"
export * from "./SelfPaced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports